import { render, staticRenderFns } from "./LockedUsers.vue?vue&type=template&id=43a4ad2a&"
import script from "./LockedUsers.vue?vue&type=script&lang=js&"
export * from "./LockedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports